@let history = (history$ | async) ?? [];
@let isHistoryLoading = historyLoadingStatus() === LoadingState.LOADING;
@let isHistoryLoaded = historyLoadingStatus() === LoadingState.READY;

<section class="page-content page-viewport">
  <mon-page-toolbar
    titleTranslateKey="monitoring.menu.history"
    [selectedFiltersCount]="selectedFiltersCount"
  >
    <div
      toolbarInlineControls
      class="toolbar-date-picker--icon-only"
      [formGroup]="historyFormFilters"
    >
      <lib-date-picker
        class="history__filter"
        [placeholder]="'monitoring.select-date' | translate"
        mode="range"
        formControlName="datePeriod"
      />
    </div>

    <div
      toolbarFilters
      class="history__filters"
      [formGroup]="historyFormFilters"
    >
      @if (canReadUsers()) {
        <mon-user-selector
          class="history__filter"
          [controlEntity]="getHistoryFiltersControl('userIds')"
          (selectionChange)="onUsersSelectionChange($event)"
        />
      }
    </div>

    @if (isFiltersActive) {
      <div
        toolbarSelectedFilters
        class="history__selected-filters"
      >
        <lib-button
          (click)="clearAllFilters()"
          class="chip chip--button"
          buttonStyle="danger"
          buttonSize="medium"
          buttonType="button"
        >
          <span> {{ 'monitoring.clear-filters' | translate }} </span>
        </lib-button>

        @for (filter of allSelectedFilters; track filter[0]) {
          @for (selectedFilter of filter[1]; track selectedFilter.id) {
            <lib-button
              (click)="deselectFilter(filter[0], selectedFilter)"
              class="chip chip--button"
              buttonStyle="danger"
              buttonSize="medium"
              buttonType="button"
            >
              <lib-svg-icon
                icon="close"
                size="16"
              />
              <span> {{ selectedFilter.name | translate }} </span>
            </lib-button>
          }
        }
      </div>
    }
  </mon-page-toolbar>

  <section class="page-content page-table page-table-scroll">
    <div class="page-table-scroll__content">
      <lib-table
        class="page-table-scroll__table"
        [columns]="columns"
        [dataSource]="history"
        [cellTemplates]="{
          user: userTpl,
          action: actionTpl,
          entityType: entityTypeTpl,
          details: detailsTpl,
          entityChangedDate: entityChangedDateTpl,
        }"
        [loaded]="isHistoryLoaded"
        [loading]="isHistoryLoading"
        (sortColumnChange)="sortHandler($event)"
      ></lib-table>
    </div>

    <!-- пагинация -->
    @if (!(history.length === 0 && currentPage() === 1)) {
      <lib-pagination
        [totalCount]="historyTotalCount()"
        [loading]="isHistoryLoading"
        [pageIndex]="currentPage()"
        [pageSize]="100"
        (paginationChange)="onPageChange($event)"
      ></lib-pagination>
    }
  </section>

  <!-- Пользователь -->
  <ng-template
    #userTpl
    let-row="data"
  >
    <div class="history__cell">
      <div class="history__cell-name">{{ row?.user?.fullName || '—' }}</div>
      <div class="history__cell-email">{{ row?.user?.email || '-' }}</div>
    </div>
  </ng-template>

  <!-- Действие (описание) -->
  <ng-template
    #actionTpl
    let-row="data"
  >
    <div class="history__cell">
      {{ row?.action ? (`monitoring.history.actions.${row?.action}` | translate) : '—' }}
    </div>
  </ng-template>

  <!-- Объект действия -->
  <ng-template
    #entityTypeTpl
    let-row="data"
  >
    <div class="history__cell">{{ row?.entityType || '—' }}</div>
  </ng-template>

  <!-- Комментарий / Детали -->
  <ng-template
    #detailsTpl
    let-row="data"
  >
    <div
      class="history__cell-details"
      (click)="onDetailsClick(row)"
    >
      {{ 'monitoring.history.dashboard.details' | translate }}
    </div>
  </ng-template>

  <!-- Дата и время -->
  <ng-template
    #entityChangedDateTpl
    let-row="data"
  >
    <div class="history__cell">
      <div>{{ row?.entityChangedDate | date: 'dd.MM.yyyy' : 'UTC' }}</div>
      <div class="history__cell-time">
        {{ row?.entityChangedDate | date: 'HH:mm:ss' : 'UTC' }} (UTC)
      </div>
    </div>
  </ng-template>
</section>
